<Panel px="md" py="md" bg="light-" rounded="xs" border-bottom="2px solid white">

  <Heading md color="muted" mb="md">
    Datos del conector registrados al instalarse y ejecutarse por primera vez
  </Heading>

  <SimpleInput label="Nombre" required bind:value={data.title}/>

  <SimpleTextarea label="Descripcion" bind:value={data.descr} />

  <SimpleSelect 
    label="Configuracion activa" bind:value={data.active_config} 
    stacked
    options={configOptions} size="32"
    hints="Define si usa la configuracioń local (archivos) o remota (desde Studio)"
    />

  <SimpleSelect label="Estado" bind:value={data.state} options={stateOptions} size="20"/>

  <SimpleInput label="UID" bind:value={data.uuid} disabled/>

  <SimpleInput label="Plataforma" bind:value={data.platform_name} disabled/>

  <SimpleInput label="Versión de plataforma" bind:value={data.platform_version} disabled/>

  <SimpleInput label="Equipo" bind:value={data.computer_name} disabled/>

  <SimpleInput label="Registrado el" bind:value={data.created_date} disabled/>

  <SimpleInput label="Versión del conector" bind:value={data.version} disabled/>

    <!-- <li class="JsonCtrl hidden" property="data">
      <Label>Json</Label>
      <Textarea cols=40 rows=3 disabled="disabled"></Textarea>
    </li> -->

</Panel>

<script>
  import { Panel, Heading, Label } from 'svelte-stylo'
  import SimpleInput from '@/components/forms/SimpleInput.svelte'
  import SimpleTextarea from '@/components/forms/SimpleTextarea.svelte'
  import SimpleSelect from '@/components/forms/SimpleSelect.svelte'

  export let data = {};
  
  const stateOptions = [
    { value: 'A', text: 'Activo'},
    { value: 'I', text: 'Inactivo'},
    { value: 'X', text: 'Eliminado'},
  ]

  const configOptions = [
    { value: '-1', text: 'Local (usa archivos del lugar donde esta instalado)'},
    { value: '1', text: 'Activa (actualiza la configuración desde Studio)'},
  ]

</script>
